module.exports = __webpack_public_path__ + "img/logo.a1b1e6e6.png";